import { render, staticRenderFns } from "./ring-group-selector.vue?vue&type=template&id=7be516f4"
import script from "./ring-group-selector.vue?vue&type=script&lang=js"
export * from "./ring-group-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports